
import React from 'react';
import { Link } from 'react-router-dom';
import { FormField, FormItem, FormControl, FormLabel, FormMessage } from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { UseFormReturn } from 'react-hook-form';
import { CardFormValues } from './CardVerificationForm';

interface TermsCheckboxProps {
  form: UseFormReturn<CardFormValues>;
  onCheckedChange: (checked: boolean) => void;
}

const TermsCheckbox: React.FC<TermsCheckboxProps> = ({ form, onCheckedChange }) => {
  return (
    <FormField
      control={form.control}
      name="termsAccepted"
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0 pt-2">
          <FormControl>
            <Checkbox
              checked={field.value}
              onCheckedChange={(checked) => {
                field.onChange(checked);
                onCheckedChange(!!checked);
              }}
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel className="text-sm font-normal">
              I accept the <Link to="/policy" target="_blank" className="text-blue-600 hover:text-blue-500">Terms and Conditions</Link> and <Link to="/privacy" target="_blank" className="text-blue-600 hover:text-blue-500">Privacy Policy</Link>
            </FormLabel>
            <FormMessage />
          </div>
        </FormItem>
      )}
    />
  );
};

export default TermsCheckbox;
